var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIncrease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arrow-Up-Graph-Increase--Streamline-Atlas.svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Arrow Up Graph Increase Streamline Icon: https://streamlinehq.com")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6476500000000005 31.667166666666667H12.588475V42.07869166666667H5.6476500000000005Z",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.411525 17.803341666666668H40.35254166666667V42.07869166666667H33.411525Z",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.529491666666665 24.726150000000004H26.470508333333335V42.07869166666667H19.529491666666665Z",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1951583333333335 42.07869166666667H43.80484166666667",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.941016666666666 3.9215H38.608183333333336V12.588475",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6476500000000005 19.529491666666665C16.7578 19.540608333333335 27.415233333333333 15.127291666666668 35.26475000000001 7.264741666666667L38.608183333333336 3.9215",
    fill: "none",
    stroke: "#6571fe",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncrease);
export default __webpack_public_path__ + "static/media/icon-increase.11040cba2f1d068912e99b1e0b8243a7.svg";
export { ForwardRef as ReactComponent };